import { render, staticRenderFns } from "./listCheckbox.vue?vue&type=template&id=50ef3f0b&"
import script from "./listCheckbox.vue?vue&type=script&lang=js&"
export * from "./listCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports